import {
  FETCH_ORPHAN_COURSES_BEGIN,
  FETCH_ORPHAN_COURSES_FULFILLED,
  FETCH_ORPHAN_COURSES_REJECTED,
  FETCH_COURSES_LIST_BEGIN,
  FETCH_COURSES_LIST_REJECTED,
  FETCH_COURSES_LIST_FULFILLED,
  FETCH_SIXMONTHS_COURSES_LIST_BEGIN,
  FETCH_SIXMONTHS_COURSES_LIST_REJECTED,
  FETCH_SIXMONTHS_COURSES_LIST_FULFILLED,
} from "../actions/coursesActions";

export function coursesListReducer(
  state = {
    loading: false,
    result: [],
    slimResult: [],
    error: null,
    orphanCourses: [],
  },
  action
) {
  switch (action.type) {
    case FETCH_COURSES_LIST_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_COURSES_LIST_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_COURSES_LIST_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    }
    case FETCH_SIXMONTHS_COURSES_LIST_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_SIXMONTHS_COURSES_LIST_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_SIXMONTHS_COURSES_LIST_FULFILLED: {
      return {
        ...state,
        loading: false,
        slimResult: action.payload,
      };
    }
    case FETCH_ORPHAN_COURSES_BEGIN: {
      return {
        ...state,
        loading: true,
      };
    }
    case FETCH_ORPHAN_COURSES_FULFILLED: {
      return {
        ...state,
        loading: false,
        orphanCourses: action.payload,
      };
    }
    case FETCH_ORPHAN_COURSES_REJECTED: {
      return {
        ...state,
        loading: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
